import { parseDate } from '@internationalized/date';

export const getLocalDate = () => {
  const now = new Date();
  const localIsoDateString = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('-');

  return parseDate(localIsoDateString);
};
